import React from 'react';
import { List } from 'antd';
import ResultDimensions from './../ResultDimensions';
import ResultCountryMap from './../ResultCountryMap';
import ResultAge from './../ResultAge';
import ResultPlants from './../ResultPlants';
import ResultGender from './../ResultGender';
import ResultSimple from './../ResultSimple';
import ResultMonths from './../ResultMonths';

function getStepComponent(questId) {
	if (questId === 0) {
		return ResultAge;
	}
	if (questId === 1) {
		return ResultCountryMap;
	}
	if (questId === 2 || questId === 19) {
		return ResultGender;
	}
	if (questId === 21) {
		return ResultMonths;
	}
	if (questId === 4) {
		return ResultDimensions;
	}
	if (questId === 18) {
		return ResultPlants;
	}
	return ResultSimple;
}


function Step({ id, stepAnswers, ...props }) {
	if (!stepAnswers) return null;
	let StepComponent = getStepComponent(parseInt(id, 10));
	return (
		<List.Item>
			<StepComponent {...props} id={id} stepAnswers={stepAnswers}/>
		</List.Item>
	);
}

export default Step;



// WEBPACK FOOTER //
// ./src/components/ResultStep/ResultStep.js